import { render, staticRenderFns } from "./ApplyNewConn.vue?vue&type=template&id=0a68e5fa&scoped=true&"
import script from "./ApplyNewConn.vue?vue&type=script&lang=js&"
export * from "./ApplyNewConn.vue?vue&type=script&lang=js&"
import style0 from "./ApplyNewConn.vue?vue&type=style&index=0&id=0a68e5fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a68e5fa",
  null
  
)

export default component.exports